export default __webpack_public_path__ + "static/0160-3febe35be15e11740d1b0b656d2bf3b6.png";